import { rotaDeFabricacao } from "@/router/rotas/Materiais";
const metaPadrao = {
    subject: ['PROJETO_FABRICA'],
    showMenu: true,
    grupo: "Projetos Fábrica",
    grupoTitle: "Projetos Fábrica",
}
const rotas = [
    {
        path: '/fabricacao/:obra',
        layoutNome: 'LayoutFabricacao',
        component: () => import("@/layout/LayoutFabricacao.vue"),
        meta: {
            icon: 'mdi-mdi-account',
            subject: [],
            showMenu: false,
        },
        children: [
            {
                path: '',
                name: 'Fabricação',
                component: () => import("@/views/Fabricacao/DashboardFabricacao.vue"),
                meta: {
                    breadcrumb: "Todas as Fabricações",
                    title: "Fabricação",
                    icon: 'mdi-view-dashboard-outline',
                    showMenu: false,
                    subject: ['FABRICACAO', 'PROJETO_FABRICA'],
                },
            },
            {
                path: 'usuarios/adicionar',
                name: 'Adicionar Usuários',
                component: () => import('@/views/AdicionarUsuario.vue'),
                meta: {
                    breadcrumb: 'Todas as Fabricações|Fabricação',
                    obraObrigatoria: true,
                    title: "Adicionar Usuários",
                    icon: 'mdi-account-multiple-plus-outline',
                    action: ['adicionar_cliente'],
                    subject: ['PROJETO_FABRICA'],
                    showMenu: true,
                },
            },
            {
                path: '/fabricacao/nova',
                name: 'Nova Fabricação',
                component: () => import("@/views/Fabricacao/NovoProdutoServico.vue"),
                meta: {
                    breadcrumb: "Todas as Fabricações",
                    icon: "mdi-toy-brick-plus-outline",
                    title: "Nova Fabricação",
                    acessoRapido: false,
                    showMenu: true,
                    subject: ['FABRICACAO'],
                    action: ['write'],
                },
            },
            {
                path: '/fabricacao/:obra/atualizar',
                name: 'Atualizar Fabricação',
                component: () => import("@/views/Fabricacao/UpdateProdutoServico.vue"),
                meta: {
                    breadcrumb: "Todas as Fabricações|Fabricação",
                    title: "Atualizar Fabricação",
                    icon: "mdi-pencil",
                    acessoRapido: false,
                    showMenu: true,
                    subject: ['FABRICACAO'],
                    action: ['update'],
                },
            },
            {
                path: '/:obra/fabricacao/Dashboard',
                name: 'Fabrica Dashboard Obra',
                component: () => import("@/views/CREObras/ListarDashboardGeralObra.vue"),
                meta: {
                    breadcrumb: 'Todas as Fabricações|Fabricação',
                    title: "Fabrica Dashboard Obra",
                    icon: 'mdi-view-dashboard-outline',
                    ...metaPadrao,
                    action: ['admin_projetos_fabrica'],
                },
            },
            {
                path: 'projetos',
                name: 'Projetos de fabrica',
                component: () => import("@/views/CREObras/DashboardFabrica.vue"),
                meta: {
                    breadcrumb: 'Todas as Fabricações|Fabricação',
                    title: "Projetos de fabrica",
                    icon: 'mdi-text-box-multiple-outline',
                    ...metaPadrao

                },
            },
            {
                path: 'projetos/Mecanica',
                name: 'Mecânica de Fábrica',
                component: () => import("@/views/CREObras/DashboardFabrica.vue"),
                meta: {
                    breadcrumb: 'Todas as Fabricações|Fabricação',
                    title: "Mecânica",
                    icon: 'mdi-tools',
                    query: { categoria: 'Mecânica' },
                    ...metaPadrao
                },
            },
            {
                path: 'projetos/Eletrica',
                name: 'Elétrica de Fábrica',
                component: () => import("@/views/CREObras/DashboardFabrica.vue"),
                meta: {
                    breadcrumb: 'Todas as Fabricações|Fabricação',
                    title: "Elétrica",
                    icon: 'mdi-lightning-bolt',
                    query: { categoria: 'Elétrica' },
                    ...metaPadrao
                },
            },
            {
                path: "/produto/taf/:obra",
                name: "TAF Produto",
                component: () => import("@/views/Produto/DashboardTafProduto.vue"),
                meta: {
                breadcrumb: "",
                title: "TAF Produto",
                icon: "mdi-text-box-multiple-outline",
                subject: ["TAF"],
                showMenu: true,
                grupo: "Produto",
                grupoTitle: "Produto",
                },
            },
            ...rotaDeFabricacao
        ]
    },
    {
        path: '',
        layoutNome: 'LayoutGeral',
        component: () => import("@/layout/LayoutGeral.vue"),
        meta: {
            showMenu: false,
        },
        children: [
            {
                path: '/fabricacao/nova',
                name: 'Nova Fabricação',
                component: () => import("@/views/Fabricacao/NovoProdutoServico.vue"),
                meta: {
                    icon: "mdi-toy-brick-plus-outline",
                    title: "Nova Fabricação",
                    breadcrumb: 'Todas as Fabricações',
                    acessoRapido: false,
                    showMenu: true,
                    grupo: "FABRICACAO",
                    grupoTitle: "Fabricação",
                    subject: ['FABRICACAO'],
                    action: ['write'],
                },
            },
            {
                path: '/fabricacao',
                name: 'Todas as Fabricações',
                component: () => import("@/views/Fabricacao/TodasFabricacoes.vue"),
                meta: {
                    title: "Todas as Fabricações",
                    icon: "mdi-toy-brick-search-outline",
                    acessoRapido: false,
                    showMenu: true,
                    subject: ['FABRICACAO'],
                },
            },
            {
                path: '',
                name: 'Fabricação Home',
                component: () => import("@/views/Fabricacao/FabricacoesHome.vue"),
                meta: {
                    breadcrumb: "",
                    title: "Fabricação Home",
                    icon: 'mdi-view-dashboard-outline',
                    showMenu: false,
                    subject: ['FABRICACAO', 'PROJETO_FABRICA'],
                },
            },
            {
            path: '/fabrica/Dashboard',
            name: 'Fabrica Dashboard',
            component: () => import("@/views/CREObras/ListarDashboardGeralObra.vue"),
            meta: {
                breadcrumb: '',
                title: "Fabrica Dashboard",
                icon: 'mdi-view-dashboard-outline',
                ...metaPadrao,
                action: ['admin_projetos_fabrica'],
            },
        },

            {
                path: 'projetos-fabrica',
                name: 'Todos projetos de fábrica',
                component: () => import("@/views/CREObras/DashboardGeralFabrica.vue"),
                meta: {
                    breadcrumb: 'Todas as Fabricações',
                    title: "Todos projetos de fábrica",
                    icon: 'mdi-text-box-multiple-outline',
                    ...metaPadrao
                },
            },
            {
                path: 'projetos-fabrica/Eletrica',
                name: 'Elétrica geral de Fábrica',
                component: () => import("@/views/CREObras/DashboardGeralFabrica.vue"),
                meta: {
                    breadcrumb: 'Todas as Fabricações|Todos projetos de fábrica',
                    title: "Elétrica",
                    icon: 'mdi-lightning-bolt',
                    query: { categoria: 'Elétrica' },
                    ...metaPadrao
                },
            },
            {
                path: 'projetos-fabrica/Mecanica',
                name: 'Mecânica geral de Fábrica',
                component: () => import("@/views/CREObras/DashboardGeralFabrica.vue"),
                meta: {
                    breadcrumb: 'Todas as Fabricações|Todos projetos de fábrica',
                    title: "Mecânica",
                    icon: 'mdi-tools',
                    query: { categoria: 'Mecânica' },
                    ...metaPadrao
                },
            },
        ]
    }
]

export default rotas;